import React from "react";

// A rupee sign with one arrow going out and one coming in: money moving both ways,
// for Transactions / Activity. Same outline style and props as the react-feather
// icons (and WalletOutIcon) so it lines up with them.
const MoneyInOutIcon = ({ size = 24, color = "currentColor", strokeWidth = 2, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...rest}
  >
    {/* ₹ */}
    <path d="M3 4h9" />
    <path d="M3 8h9" />
    <path d="M6.5 4a4 4 0 0 1 0 8H3l7 8" />
    {/* out: arrow up */}
    <path d="M15.5 13V3" />
    <path d="m13.5 5 2-2 2 2" />
    {/* in: arrow down */}
    <path d="M20.5 11v10" />
    <path d="m18.5 19 2 2 2-2" />
  </svg>
);

export default MoneyInOutIcon;
